import React from 'react';
import { ArrowRight } from 'lucide-react';
interface CTAButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  className?: string;
  showIcon?: boolean;
}
export function CTAButton({
  children,
  onClick,
  className = '',
  showIcon = true
}: CTAButtonProps) {
  const handleClick = () => {
    if (onClick) {
      onClick();
    } else {
      window.open('https://woman90dayprotocol.com/cart/48957448421616:1', '_blank');
    }
  };
  return <button onClick={handleClick} className={`group relative inline-flex items-center justify-center gap-3 bg-coral hover:bg-coral-dark text-white font-heading font-bold text-lg md:text-xl py-4 px-8 rounded-full shadow-warm transition-all duration-300 hover:shadow-warm-lg hover:-translate-y-1 active:translate-y-0 ${className}`} aria-label={typeof children === 'string' ? children : 'Call to action button'} data-id="element-18">
      <span data-id="element-19">{children}</span>
      {showIcon && <ArrowRight className="w-5 h-5 transition-transform duration-300 group-hover:translate-x-1" data-id="element-20" />}
    </button>;
}